import { createPlaceholder } from './lib/createPlaceholder';
import { getImageSource } from './lib/getImageSource';
import { Image, ImageStyle } from './lib/image';
import { Images } from './lib/images';
import { isSupportedImage } from './lib/isSupportedImage';

export { ImageStyle, Image, Images, createPlaceholder, getImageSource, isSupportedImage };
